import React from 'react'
import {Route} from 'react-router-dom'

const PublicRoute = ({component, render, ...rest}) => <Route {...rest} component={component} render={render} />

export default PublicRoute
